"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTranslatable = void 0;
/**
 * Formats a given `Translatable` as a translated string.
 *
 * @hidden
 * @param value The `Translatable` value to be formatted.
 * @param languageTag The IETF tag of the language to translate to.
 * @returns The translated string.
 */
var formatTranslatable = function (value, languageTag) {
    var translations = value.translations, defaultText = value.text;
    if (!translations || translations.length === 0)
        return defaultText;
    var translation = translations.find(function (t) { return t.languageTag === languageTag; });
    return translation ? translation.text : defaultText;
};
exports.formatTranslatable = formatTranslatable;
//# sourceMappingURL=format-translatable.js.map